import { useInvoices } from "@/contexts/InvoicesContext";
import { styles } from "@/pages/InvoicesPage.styles";
import * as shared from "@/styles/shared";
import type { PageSizeBarProps } from "@/types/ui";
import { useTranslation } from "react-i18next";

const PageSizeBar = ({ pageSizeOptions }: PageSizeBarProps) => {
  const { limit, handlePageSizeChange } = useInvoices();
  const { t } = useTranslation(["common", "invoices"]);
  return (
    <div className={styles.pageSizeBar}>
      <span className={shared.muted}>{t("show", { ns: "invoices" })}</span>
      <select value={limit} onChange={(e) => handlePageSizeChange(Number(e.target.value))} className={styles.pageSizeSelect}>
        {pageSizeOptions.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
      <span className={shared.muted}>{t("perPage", { ns: "invoices" })}</span>
    </div>
  );
};

export { PageSizeBar };
